import omitProps from '@hocs/omit-props';

export default omitProps('performance');
